import ListingInfoSingle from './listingInfoSingle'

export default ListingInfoSingle
